import React from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

const OfflineBanner = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '4rem',
      left: 0,
      right: 0,
      background: '#f59e0b',
      color: 'white',
      padding: '0.75rem 1rem',
      textAlign: 'center',
      zIndex: 9998,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      fontSize: '0.875rem',
      fontWeight: '600'
    }}>
      🔴 Offline-Modus - Änderungen werden lokal gespeichert und synchronisiert sobald Sie wieder online sind
    </div>
  );
};

export default OfflineBanner;
